<template>
  <el-popover
      placement="bottom"
      width="320"
      popper-class='public_mark'
      v-model='row.isPopoverShow'
      trigger="manual">
      <div >
      	<el-radio v-model="row.signId_c" v-for='i in markList' :label="i.id" :key='i.id'
      	@change='handleRadioChange(row,$event)'>
      		<i class='iconfont iconlastTime' :style='{fontSize: size,color: i.color}'></i>
      	</el-radio>
      </div>
      <div class='mark_item'>
      	<el-input type='textarea'  maxlength='80' show-word-limit placeholder="请输入标记原因"
      		v-model='row.signReason_c'
      		resize='none'
      		clearable
      		@focus='handleInputFocus'
      		:autosize='{minRows: 3, maxRows: 6 }'
      	></el-input>

      </div>
      <div style='text-align: center;' class='mark_item'>
      	<el-button size='small' @click='handleHideChange(row)'>取消</el-button>
      	<el-button size='small' @click='saveMark(row)' type='primary'>确认</el-button>
      </div>
     	 <i  class='iconfont iconlastTime' :style='retunMarkStyle(row)'
       :title="row.signReason"
     	 slot="reference"
       @click.stop='clickPopoverShow(row)'></i>
  </el-popover>
</template>

<script>
  export default {
    props:{
      rows:{
        type:Object,
        default:()=>{ return {} }
      },
      size:{
        type:String,
        default:"16px"
      }
    },
    data() {
      return {
        markList:[
        	{id:1,color:'#999'},
        	{id:2,color:'green'},
        	{id:3,color:'#f5a623'},
        	{id:4,color:'#e5691f'},
        	{id:5,color:'#d0021b'},
        ],
        row:{}
      }
    },
    watch:{
      rows:{
        handler(val) {
          if(val&&val.id) {
            this.row = this.$lodash.cloneDeep(val);
          }
        },
        immediate:true
      }
    },
    methods:{
      // 操作标记点击
      clickPopoverShow(row) {
      	this.nowRowClickData = row;
      	row.isPopoverShow = !row.isPopoverShow;
      },
      // 保存
      saveMark() {
        this.row.isPopoverShow = false;
        this.$emit('saveMark',this.row)
      },
      // 返回标记颜色
      retunMarkStyle(row) {
      	let params = {
      		fontSize:this.size?this.size:"20px",
      		cursor:"pointer",
      		color:"",
      	}

      	switch(row.signId) {
      		case 1:
      			params.color='#999';
      			break;
      		case 2:
      			params.color='green';
      			break;
      		case 3:
      			params.color='#f5a623';
      			break;
      		case 4:
      			params.color='#e5691f';
      			break;
      		case 5:
      			params.color='#d0021b';
      			break;
      	}
      	return params
      },
      // 得到焦点全选文字
      handleInputFocus(e){
      	e.target.select();
      },
      // 隐藏时同步理由和选项
      handleHideChange(row) {
      	row.isPopoverShow = false;
      	setTimeout(()=>{
      		row.signReason_c = row.signReason;
      		row.signId_c = row.signId;
      	},300)

      },
      handleRadioChange(row,val) {
      	row.signReason_c = row.signReason;
      },
    }
  }
</script>

<style lang="less">
  .public_mark {
  	.mark_item {
  		margin-top: 20px;
  	}
  	.el-radio {
  		margin-right: 10px;
  	}

  }
</style>



// WEBPACK FOOTER //
// src/pages/cashier/components/c-query-table/c-mark.vue